import React from 'react';

// --- Data for the Benefits List ---
// TODO: Replace these placeholder URLs with your actual image links.
const benefitsLeft = [
  { title: "Daily Live Classes", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Daily classes.png" },
  { title: "Daily Class Recordings", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Daily class rec.png" },
  { title: "Premium Notes", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Premium Notes.png" },
  { title: "Practical Assignments", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Practical Assignments.png" },
  { title: "24/7 Doubt Support", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Don't Support.png" },
  { title: "Real-time projects", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/real time projects.png" }
];

const benefitsRight = [
  { title: "Placement Training", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Placement Trainings.png" },
  { title: "Mock Interviews", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Mock Interviews.png" },
  { title: "Hacking Labs", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Hacking Labs.png" },
  { title: "Hacking Tools", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Hacking Tools.png" },
  { title: "Training Certificate", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Training Cert.png" },
  { title: "Project completion certificate", icon: "https://skillsuprise.com/data/cyberPDF/Benifits/Proj Cert.png" }
  
];


// --- Internal CSS for the Benefits Section ---
const internalCSS = `

.dashboard-banner {
    width: 100%;
    max-height: 450px; 
    object-fit: cover;
    object-position: top center;
    background-color: #000; /* Placeholder bg */
  }

  /* --- 7. Benefits Section --- */
  .benefits-section {
    background-color: #fff;
    padding: 4rem 1rem;
    text-align: center;
  }
  .benefits-title {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #004a99; /* Blue */
    line-height: 1.2;
  }
  .benefits-subtitle {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    color: #198754; /* Green */
    line-height: 1.2;
  }
  .benefit-item {
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 1.15rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 0.9rem;
  }
  
  .benefit-image-icon {
    width: 40px;      
    height: 40px;     
    object-fit: contain; 
    margin-right: 1.25rem;
    min-width: 40px; 
  }

  /* --- MODIFIED: Responsive Adjustments --- */
  @media (max-width: 767.98px) {
    .benefits-section {
      padding: 2rem 0.5rem; /* Reduced padding */
    }
    .benefits-title {
      font-size: 1.2rem;
    }
    .benefits-subtitle {
      font-size: 2.2rem;
    }
    .benefit-item {
      /* Adjust font size for smaller 50% column */
      font-size: 0.7rem; 
      /* Removed justify-content: center */
    }
    
    .benefit-image-icon {
      /* Adjust icon size for smaller 50% column */
      width: 25px;
      height: 25px;
      min-width: 25px;
      margin-right: 0.5rem; /* Reduced margin */
    }
  }
`;

const BenefitsSection = () => {
  return (
    <>
      <style>{internalCSS}</style>

      <div>
        <img 
          src="https://skillsuprise.com/data/cyberPDF/dashboard.png" // TODO: Replace this URL
          alt="dash Banner" 
          className="dashboard-banner"
        />
      </div>

      {/* --- BENEFITS SECTION --- */}
      <div className="benefits-section">
        <div className="container-fluid"> {/* Use container-fluid for more space */}
          <h1 className="benefits-title">Life-Time Course Access</h1>
          <h2 className="benefits-subtitle">With Unlimited Benefit's</h2>
          
          <div className="row g-2 mt-4"> {/* Reduced gutters (g-2) */}
            
            {/* MODIFIED: 'col-6' makes it 50% on ALL screen sizes */}
            <div className="col-6">
              {benefitsLeft.map((item, index) => (
                <div className="benefit-item" key={index}>
                  <img 
                    src={item.icon} 
                    alt={`${item.title} icon`} 
                    className="benefit-image-icon" 
                  />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
            
            {/* MODIFIED: 'col-6' makes it 50% on ALL screen sizes */}
            <div className="col-6">
              {benefitsRight.map((item, index) => (
                <div className="benefit-item" key={index}>
                  <img 
                    src={item.icon} 
                    alt={`${item.title} icon`} 
                    className="benefit-image-icon" 
                  />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BenefitsSection;